import CartTotal from "components/Cart/CartTotal"
import ProductTable from "components/Product/ProductTable"
import { observer } from "mobx-react"
import React, { Component } from "react"
import { Link } from "react-router-dom"
import { Button, Message,Table,Icon } from "semantic-ui-react"
import shop from "shop/shop"
import track from "shop/track"
import cmsStore from "stores/cmsStore.js"
import "style/CheckoutPage.scss"
import HeaderCheckout from "pages/checkout/HeaderCheckout"
import FooterCheckout from "pages/checkout/FooterCheckout"
import queryString from "qs"
import CartExport from "components/Cart/CartExport"
import Price from "components/Price/Price"
import CostCentres from "../../../../components/CostCentres/CostCentres";

@observer
export default class CheckoutPage extends Component {
  
  state = {
    products: getProducts(),
    frachtkosten: true,
    productsTemp: []
  }
  
  componentDidMount() {
    shop.cart.hooks.changed.add( this.updateCart )
    shop.cart.hydrate()
    track.checkout( { step: 1, products: shop.cart.products } )
    shop.cart.update()
  }
  
  handleChange = ( { product } ) => {
    shop.cart.add( product )
  }
  
  updateCart = () => {
    let products = getProducts()
    products = getProducts()
    this.setState( { products } )
    this.forceUpdate()
  }
  
  componentWillUnmount() {
    this.setState({productsTemp: shop.cart.products})
    shop.cart.hooks.changed.remove( this.updateCart )
  }
  
  render() {
    const { referer = "/", ...query } = queryString.parse( location.search, { ignoreQueryPrefix: true } )
    let { products, frachtkosten } = this.state
    const { loading } = shop.cart
    const { checkoutType } = this.props.match.params
    const isRequest = !!checkoutType
    //console.log("frachtkosten",frachtkosten)
    // MINDERMENGENZUSCHLAG UNTER 50 EUR
    const MIN_ORDER = shop.config.MIN_ORDER_PENALTY_VALUE
    
    const showPenaltyNotice = shop.cart.sum < MIN_ORDER
    console.log("products Checkout",products)
    return (
      <div className=" ">
        <HeaderCheckout activeStep={0} isRequest={isRequest} referer={referer}/>
        
        {/*<section className="container pb4">
          <CostCentres />
        </section>*/}
  
        <section className="container">
          
          <ProductTable readOnly={false} cart={shop.cart} onChange={this.handleChange} products={products}/>

          {/*showPenaltyNotice && <Message>
            <div>{translate( "MIN_ORDER_VALUE_NOTICE", { value: `${shop.config.MIN_ORDER_PENALTY_VALUE}` } )}</div>
      </Message>*/}
      						{shop.cart.sum <= shop.config.MIN_ORDER_VALUE &&
						<div className="cf pb2 pt3">
							<Message negative className="">
								<div className="total ">
									<div className="ph3">
										<Icon name="info" />{translate( "minimum order value not reached" )}
										<span className="pull-right">
                    						<Price>{shop.config.MIN_ORDER_VALUE}</Price>
								     </span>
									</div>
								</div>
								
							</Message>
						</div>
						}


          {cmsStore.pluginData.export && <div className="pv3">
            <CartExport/>
          </div>}
        </section>
        
     <FooterCheckout  activeStep={0}/>
        {/*      <section className="mb4 ">
          <div className="container">
              <Table className="productTableCheckoutContinue"  compact>
                <tbody>
                  <tr>
                    <td className="tl">
                              <div className="pb3" >
                                <Link className={"logo"} to="/home/">
                                  <img
                                    src={shop.config.logo}
                                    alt="" />
                                </Link>
                                </div>
                                </td>
                                               <td className="tl">
                              <div className="" >
                                <table>
                                  <colgroup>
                                    <col width="50%"/>
                                    <col width="50%"/>
                                  </colgroup>
                                  <tbody>
                                    <tr>
                                      <td colSpan="2" className="pt3">
                                      <p className="f4 fw7">{translate("Sie benötigen Hilfe bei Ihrer Bestellung?")}</p>
                                      </td>
                                      </tr>
                                    <tr>
                                      <td className="pt3">
                                        <a href={`tel:+49407392040`}><span className="f5 fw5" style={{ color: "#369678", backgroundColor: "transparent" }}><Icon
                                                  name={"phone"} />+49-40-739204-0 </span></a>
                                        </td>
                                      <td className="pt3">
                                        <a href={`mailto:shop@herenz.de?subject=Anfrage bezüglich des Bestellvorgangs, Kunde #${shop.session.value.map_id}`}>
                                          <span className="f5 fw5" style={{ color: "#369678", backgroundColor: "transparent" }}><Icon
                                        name={"mail"} />shop@herenz.de</span></a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                </div>
                                </td>     
                    <td className="pb3 ">
                      <div className="flex flex-row justify-end ">
                        <table>
                          <tbody>
                            <tr>
                              <td className="pt4">
                              <Link to={{
                                  pathname: `${this.props.location.pathname}delivery`,
                                  search  : this.props.location.search
                                }}>
                                  <Button
                                    loading={loading}
                                    primary style={{borderRadius: "35px", height: "50px", width: "350px"}} className="ml3 pl3">
                                    {translate( "WeiterShoppingCart" )}
                                    <i className="icon-angle-right"/>
                                  </Button>
                                </Link>
                              </td>
                            </tr>
                            <tr>
                              <td>
                              <Link className={"mr3"} to={referer}>
                                <Button style={{borderRadius: "35px", height: "50px", width: "350px"}} className="ml3 pl3">
                                  <i className="icon-angle-left"/>
                                  {translate( "Zurück" )}
                                </Button>
                              </Link>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>

                    </td>
                  </tr>
                </tbody>
              </Table>
              </div>
        </section>*/}
        
      </div>
    )
  }
}

const getProducts = () => shop.cart.map( ( product ) => product)



// WEBPACK FOOTER //
// ./src/theme/demo2025/pages/checkout/CheckoutPage.js